import L, { Marker } from "leaflet";

export class GeneralAboutPage {

    constructor() {

        //document.ready
        $(() => {
            var windowWidth = document.documentElement.clientWidth;
            var mapboxAccessToken = 'pk.eyJ1IjoicndhdGtpbnMtcnRpIiwiYSI6ImNrZm14OHAyYjFza3oydHA3eGMyZmdkM3YifQ.DR_itceW4yomVYL_YNZIPw';
            var sitesMap = L.map('sitesMap');
            if (windowWidth < 768) {
                sitesMap.setView([39.74739, -95.7129], 3.8);
            } else {
                sitesMap.setView([39.74739, -95.7129], 4.3);
            }

            L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=' + mapboxAccessToken, {
                id: 'mapbox/light-v9',
                attribution: 'Map tiles from <a href="https://www.mapbox.com" target="_blank">MapBox</a>.',
                tileSize: 512,
                zoomOffset: -1
            }).addTo(sitesMap);

            var healIcon = L.icon({
                iconUrl: 'images/heal_marker.png',
                iconSize: [16, 23],
            });

            var sites = [
                [33.50370957447804, -86.80250041783687, '<p><a href="https://www.uab.edu/home/" target="_blank">University of Alabama at Birmingham</a></p>'],
                [34.75011395603224, -92.3200887159583, '<p><a href="https://www.uams.edu/" target="_blank">University of Arkansas for Medical Sciences</a></p>'],
                [39.949091, -75.1573684, '<p><a href="https://www.jefferson.edu/" target="_blank">Thomas Jefferson University</a></p>'],
                [35.091368754995024, -106.61726177362108, '<p><a href="https://hsc.unm.edu/" target="_blank">University of New Mexico Health Sciences Center</a></p>'],
                [39.948348131448675, -75.1944118600004, '<p><a href="https://www.chop.edu/" target="_blank">Children’s Hospital of Philadelphia</a></p>'],
                [39.14068288842923, -84.5010742203698, '<p><a href="https://www.cincinnatichildrens.org/" target="_blank">Cincinnati Children’s Hospital Medical Center</a></p>'],
                [38.21593025156407, -85.76092794710577, '<p><a href="https://louisville.edu/" target="_blank">University of Louisville</a></p>'],
                [39.773927022315895, -86.17590859493879, '<p><a href="https://www.iupui.edu/" target="_blank">Indiana University - Purdue University at Indianapolis</a></p>']
            ];

            var markersLayer = L.layerGroup();

            for (var i = 0; i < sites.length; i++) {
                (<any>L).marker([sites[i][0], sites[i][1]], { icon: healIcon }).bindPopup(sites[i][2]).addTo(markersLayer);
            }
            markersLayer.addTo(sitesMap);

            window.addEventListener('resize', function () {
                windowWidth = document.documentElement.clientWidth;
                if (windowWidth < 768) {
                    sitesMap.setZoom(3.8);
                } else {
                    sitesMap.setZoom(4.3);
                }
            });

        });
    }

}